import { notify } from '@kyvg/vue3-notification'
import moment from 'moment'
import { camelCase } from 'lodash'
import { useNotificationsStore } from '@/stores/notificationsStore'
import { useInitDataStore } from '@/stores/initDataStore'
import { useGlobalStore } from '@/stores/globalStore'
import { NotificationInfoItem } from '@/models/initData/NotificationInfo'

export const check = async () => {
  const notificationsStore = useNotificationsStore()
  const initDataStore = useInitDataStore()
  const notificationInfo = initDataStore.initData.notificationInfo || {}

  const fetchPromises = [notificationsStore.fetchWithAfterId(), notificationsStore.fetchWithoutAfterId()]
  await Promise.all(fetchPromises)

  if (!notificationsStore.hasNotification) {
    return
  }

  notificationsStore.notifications?.items.forEach(item => {
    const status = camelCase(item.status)
    const infoItem = notificationInfo[status]

    // 通知定義が存在しない場合は無視
    if (infoItem === undefined) {
      return
    }

    const { color, bgcolor, duration } = infoItem
    const title = item.title
    const text = `[${moment(item.startTime).format('YYYY/MM/DD HH:mm')}] ${item.body}`

    // durationが0のときは非表示
    if (duration > 0) {
      notify({ title, text, color, backgroundColor: bgcolor, duration: duration * 1000 })
    }
  })

  notificationsStore.priorInfo && sound(notificationsStore.priorInfo)
}

const sound = (item: NotificationInfoItem) => {
  const globalStore = useGlobalStore()
  const { path, duration } = item.sound

  globalStore.soundPlayer.play(path, duration * 1000)
}
